import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

// * This should not be necessary when update i18next to v23.0.0
declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false
  }
}

// NI-2591: capture the init Promise so the app bootstrap can defer the first
// render until translations have loaded. Prevents raw i18n keys from leaking
// into the UI (NI-2606, NI-2591 / PR #76).
const i18nInitPromise = i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // passes i18n down to react-i18next
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: `/${process.env.REACT_APP_BASE_NAME}/locales/{{lng}}/{{ns}}.json?version=${process.env.REACT_APP_COMMIT_HASH}`
    },
    lng: 'en',
    fallbackLng: 'en',
    returnNull: false
  })

export { i18nInitPromise }
export default i18n
